// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3ba693c6","513":"45b0f2d1","703":"0ed34814"}[chunkId] + ".chunk.js";
};